'use strict';

/*global services*/

(function ($) {
  var methods = {
    init: function () {

      return this.each(function () {
        var $this = $(this);

        if ($this.hasClass('help-box-init')) {
          return;
        }

        $this.addClass('help-box-init');

        $this.data('title', $this.attr('title'));
        $this.attr('title', services.get('translator').trans('help.open'));

        $this.on('click', function () {
          var modal = services.get('modal');
          modal.empty().open({
            title: $this.data('title'),
            width: $this.data('width') ? $this.data('width') : 'md',
            height: 'auto',
            form: false
          }).content($this.html());

          return false;
        });
      });
    }
  };

  $.fn.k2_helpBox = function (methodOrOptions) {
    if (methods[methodOrOptions]) {
      return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
      return methods.init.apply(this, arguments);
    } else {
      $.error('Method ' + methodOrOptions + ' does not exists on jQuery.k2_helpBox');
    }

  };

  $.fn.k2_helpBox.defaults = {};

})(jQuery);
